import React from 'react';
import { useSelector } from 'react-redux';
import TeamPlayer from './TeamPlayer';
import Stats from './Stats';
import { Utr, UtrLabel } from '../../text';
import PickleBallRating from '../PlayerCard/SharedComponents/PickleBallRating';
import { sportTypeIds } from '../../../utils/eventConstants';

const TeamStandingsCard = (props) => {
    const {
        teamPlayers,
        utrType,
        showDecimals,
        showRatingNotLoggedIn,
        hideRatings,
        stats,
        showSeeProfileLink,
        sportTypeId,
        'data-testid': dataTestId,
    } = props;

    const isPickleBallSportType = sportTypeId === sportTypeIds.PICKLEBALL;

    const auth = useSelector(({ auth }) => auth);
    const userLoggedIn = auth?.user;

    return (
        <div className="utr-card player-card">
            <div className={`list-view d-none d-md-block`}>
                <div className="d-flex">
                    <div className="flex-grow">
                        <div className="row">
                            <div className={`col-md-4`}>
                                <div className="w-100">
                                    {teamPlayers.map((player, i) => {
                                        return (
                                            <TeamPlayer
                                                key={`team-player-${player.id}`}
                                                player={player}
                                                showSeeProfileLink={showSeeProfileLink}
                                                index={i}
                                                data-testid={dataTestId && `${dataTestId}.desktop.player-${player.id}`}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                            <div className={`col-md-8`}>
                                <div className="row w-100">
                                    {!hideRatings && (
                                        <div className={`col`}>
                                            {(userLoggedIn || showRatingNotLoggedIn) && (
                                                <React.Fragment>
                                                    <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.doubles-values`}>
                                                        {teamPlayers.map((player, i) => {
                                                            const { ratingStatusDoubles } = player;
                                                            if (isPickleBallSportType) {
                                                                return (
                                                                    <PickleBallRating player={player} key={`team-player-rating-${player.id}`} data-testid={dataTestId && `${dataTestId}.desktop.player-${player.id}.doubles-pickleball`} />
                                                                );
                                                            }

                                                            return (
                                                                <div key={`team-player-rating-${player.id}`} className={`${i === 0 ? 'mb16' : ''}`} data-testid={dataTestId && `${dataTestId}.desktop.player-${player.id}.doubles-rating`}>
                                                                    <div
                                                                        className={`value ${utrType === 'sanctioned' && ratingStatusDoubles !== 'Rated' ? 'text-lighter' : ''}`}
                                                                        title={utrType === 'sanctioned' ? ratingStatusDoubles : ''}
                                                                        data-testid={dataTestId && `${dataTestId}.desktop.player-${player.id}.doubles-utr`}
                                                                    >
                                                                        <Utr player={player} force={{ ratingType: 'doubles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} />
                                                                    </div>
                                                                    <div className="title" data-testid={dataTestId && `${dataTestId}.desktop.player-${player.id}.doubles-label`}>
                                                                        <UtrLabel player={player} force={{ ratingType: 'doubles', utrType, typeDots: true }} sportTypeId={sportTypeId} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                    {stats && (
                                        <Stats
                                            stats={stats}
                                            data-testid={dataTestId && `${dataTestId}.desktop.stats`}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`card-view d-block d-md-none`}>
                {teamPlayers.map((player, i) => {
                    return (
                        <TeamPlayer
                            key={`team-player-${player.id}`}
                            player={player}
                            index={i}
                            showSeeProfileLink={showSeeProfileLink}
                            userLoggedIn={userLoggedIn}
                            showRatingNotLoggedIn={showRatingNotLoggedIn}
                            utrType={utrType}
                            showDecimals={showDecimals}
                            force={{ cardView: true }}
                            sportTypeId={sportTypeId}
                            data-testid={dataTestId && `${dataTestId}.mobile.player-${player.id}`}
                        />
                    );
                })}
                <div className="row profile-details">
                    {stats && (
                        <Stats
                            stats={stats}
                            force={{ cardView: true }}
                            data-testid={dataTestId && `${dataTestId}.mobile.stats`}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

TeamStandingsCard.defaultProps = {
    'data-testid': null,
};

export default TeamStandingsCard;
